import { api } from './api';
import {
  ProductInfoRequest,
  ProductInfoRequestAddAttachment,
  ProductInfoRequestListResponse,
  ProductInfoRequestMessage,
  ProductInfoRequestMessageResponse,
  ProductInfoRequestResponse,
  ProductOrderRequest,
  ProductOrderRequestListResponse,
  ProductOrderRequestResponse,
  ProductRequestAttachment,
  ProductRequestUpdateStatus,
} from './types';

export const productRequestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addProductInfoRequest: builder.mutation<any, FormData>({
      query: (params) => ({
        url: `/api/product/info-request/add`,
        method: 'POST',
        body: params,
      }),
    }),
    updateProductInfoRequestStatus: builder.mutation<any, ProductRequestUpdateStatus>({
      query: (params) => ({
        url: `/api/product/info-request/${params.entityId}/update-status`,
        method: 'PATCH',
        body: {
          status: params.status,
        },
      }),
    }),
    deleteProductInfoRequest: builder.mutation<any, number>({
      query: (params) => ({
        url: `/api/product/info-request/${params}/delete`,
        method: 'DELETE',
      }),
    }),
    getProductInfoRequestList: builder.query<ProductInfoRequestListResponse, ProductInfoRequest>({
      query: (params) => ({
        url: `/api/product/info-request/list`,
        method: 'POST',
        body: params,
      }),
    }),
    getProductInfoRequestDetails: builder.query<ProductInfoRequestResponse, string>({
      query: (params) => ({
        url: `/api/product/info-request/${params}/detail`,
        method: 'GET',
      }),
    }),
    createProductInfoRequestMessage: builder.mutation<
      ProductInfoRequestMessageResponse,
      ProductInfoRequestMessage
    >({
      query: ({ requestId, formData }) => ({
        url: `/api/product/info-request/${requestId}/message/add`,
        method: 'POST',
        body: formData,
      }),
    }),
    addAttachmentToProductInfoRequest: builder.mutation<
      ProductRequestAttachment,
      ProductInfoRequestAddAttachment
    >({
      query: ({ requestId, formData }) => ({
        url: `/api/product/info-request/${requestId}/attachment/add
        `,
        method: 'POST',
        body: formData,
      }),
    }),

    // Order Request API Endpoints ---------------------
    // -------------------------------------------------

    addProductOrderRequest: builder.mutation<any, FormData>({
      query: (params) => ({
        url: `/api/product/order-request/add`,
        method: 'POST',
        body: params,
      }),
    }),
    updateProductOrderRequestStatus: builder.mutation<any, ProductRequestUpdateStatus>({
      query: (params) => ({
        url: `/api/product/order-request/${params.entityId}/update-status`,
        method: 'PATCH',
        body: {
          status: params.status,
        },
      }),
    }),
    deleteProductOrderRequest: builder.mutation<any, number>({
      query: (params) => ({
        url: `/api/product/order-request/${params}/delete`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'ProductOrderRequest', id: 'List' }],
    }),
    getProductOrderRequestList: builder.query<ProductOrderRequestListResponse, ProductOrderRequest>(
      {
        query: (params) => ({
          url: `/api/product/order-request/list`,
          method: 'POST',
          body: params,
        }),
        providesTags: [{ type: 'ProductOrderRequest', id: 'List' }],
      }
    ),
    getProductOrderRequestDetails: builder.query<ProductOrderRequestResponse, string>({
      query: (params) => ({
        url: `/api/product/order-request/${params}/detail`,
        method: 'GET',
      }),
    }),
    getNewOrdersCount: builder.query<number, void>({
      query: () => ({
        url: `/api/product/order-request/new-orders-count`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddProductInfoRequestMutation,
  useDeleteProductInfoRequestMutation,
  useGetProductInfoRequestListQuery,
  useLazyGetProductInfoRequestListQuery,
  useAddProductOrderRequestMutation,
  useDeleteProductOrderRequestMutation,
  useGetProductOrderRequestListQuery,
  useLazyGetProductOrderRequestListQuery,
  useGetProductInfoRequestDetailsQuery,
  useGetProductOrderRequestDetailsQuery,
  useCreateProductInfoRequestMessageMutation,
  useUpdateProductInfoRequestStatusMutation,
  useUpdateProductOrderRequestStatusMutation,
  useAddAttachmentToProductInfoRequestMutation,
  useGetNewOrdersCountQuery,
  useLazyGetNewOrdersCountQuery,
} = productRequestApi;
